import logo from '../assets/logo.png'
import { connectWallet,disconnectWallet } from '../SpotizContractHelper'
import { truncate, useGlobalState } from '../store'


const Header = () => {
  
  const [connectedAccount] = useGlobalState('connectedAccount');
  
  return (
    <div className='container mx-auto'>
      <nav className="flex justify-between items-center py-4 mx-auto">
        <div className="flex flex-row justify-start items-center  flex-initial">
          <a href="/" title ="Spotization" className='flex flex-row items-center'>
            <img className="w-14 cursor-pointer" src={logo} alt="spotization" />
            <span className="text-white text-2xl ml-2 md:text-md">Spotization</span>
          </a>
        </div>
        <ul
          className=" text-white 
          md:flex hidden list-none flex-row 
          justify-between items-center flex-initial"
        ><li className="mx-4 cursor-pointer"><a href="https://spotization.com/#about">A propos</a></li>
          <li className="mx-4 cursor-pointer"><a href="https://spotization.com/#sales">Vente Privée</a></li>
          <li className="mx-4 cursor-pointer"><a href="https://spotization.com/#roadmap">Feuille de route</a></li>
          <li className="mx-4 cursor-pointer"><a href="https://spotization.com/#team">L’équipe</a></li>
          <li className="mx-4 cursor-pointer"><a href="https://spotization.com/#contact">Contact</a></li>
          <li className="mx-4 cursor-pointer"><a href="https://spotization.com/Spotization%20Lightpaper%20EN%203.0.pdf">Lightpaper</a></li>
        </ul>

        {connectedAccount.account ? (
          <div className='acc-nav-wrap relative'>
            <button
              className="shadow-sm font-bold pl-3 pr-3 shadow-black text-white 
            bg-[#0c3895] hover:bg-[#1e3fc0] md:text-xs  p-2
            rounded-full cursor-pointer" >
            <span className='inline-block text-left mr-5'><span className='sub-lbl block'>Compte:</span><span className='block'>{truncate(connectedAccount.account, 4, 4, 11)}</span></span> 
            <span  className='inline-block text-left md-hidden'><span className='sub-lbl  block'>Solde du NFT:</span><span className='block'>{parseInt(connectedAccount.balance)} NFT</span></span>
            </button>
            <div className={`sub-acc-nav absolute hidden`}><ul className='wallet-disconnect'><li><a href="#"  onClick={disconnectWallet}>Déconnexion</a></li></ul></div>
          </div>
        ) : (
          <button
            className="shadow-sm pl-3 pr-3 font-bold shadow-black text-white 
          bg-[#0c3895] hover:bg-[#1e3fc0] md:text-xs sm:text-xs p-2
          rounded-full cursor-pointer"
            onClick={connectWallet}
          >
            Connecter le portefeuille
          </button>

        )}
      </nav>
    </div>
  )
}

export default Header
